import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Control, Form} from "react-redux-form";
import {Button} from "@material-ui/core";
import CustomSelect from "../../../components/custom-select/custom-select";
import {modes} from "../../../lists/mode-list";
import CustomInput from "../../../components/custom-input/custom-input";
import {getModbus, updateModbus} from "../../../services/settings.service";
import {setDataInStore} from "../../../utils/setDataInStore";
import {connect, useDispatch} from "react-redux";
import Loader from "react-loader-spinner";
import InputIcon from "@material-ui/icons/Input";
import LensIcon from "@material-ui/icons/Lens";
import _ from "lodash";
import {AppState} from "../../../store/store";

const dataRates = [{
    value: 115200
}, {
    value: 57600
}, {
    value: 38400
}, {
    value: 19200
}, {
    value: 9600
}, {
    value: 7200
}, {
    value: 4800
}, {
    value: 2400
}, {
    value: 1200
}, {
    value: 600
}, {
    value: 300
}, {
    value: 110
}];

const dataBits = [
    {
        value: 8,
    }
]

const stopBits = [
    {
        value: 0,
        label: '1',
    },
    {
        value: 1,
        label: '1.5',
    },
    {
        value: 2,
        label: '2',
    }
]

interface IMotbusOptionView {
    state: AppState
}

const MotbusOptionView: React.FC<IMotbusOptionView> = (props) => {
    const {t} = useTranslation()
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const [currentModbusStatus, setCurrentModbusStatus] = useState<boolean>(false);
    const [dissableButtons, setDissableButtons] = useState(false)
    const parity = [
        {
            value: 0,
            label: t('none'),
        },
        {
            value: 1,
            label: t('odd'),
        },
        {
            value: 2,
            label: t('even'),
        }
    ]
    useEffect(() => {
        getModbus().then(
            (res) => {
                setDataInStore(dispatch, res, 'modbus');
                setCurrentModbusStatus(_.get(res, 'active', false))
                setLoading(false)
            }
        ).catch(() => setLoading(false));
    }, [])
    const handleSubmit = (settings: any) => {
        setDissableButtons(true);
        updateModbus(_.assign({}, settings, {
            active: !currentModbusStatus
        })).finally(() => setTimeout(() => setDissableButtons(false), 1000))
        setCurrentModbusStatus(!currentModbusStatus);
    }

    const handleSave = () => {
        setDissableButtons(true);
        const modbusState = _.get(props.state, 'modbus', {});
        updateModbus(_.assign({}, modbusState, {
            active: false
        })).finally(() => setTimeout(() => setDissableButtons(false), 1000))
        setCurrentModbusStatus(false);
    }
    if (!loading) {
        return (
            <div className='d-flex justify-content-center w-100 align-items-start router-container'>
                <div className='card default-card w-100'>
                    <div className="card-body">
                        <div className='card-title-container'>
                            <span className='card-title'>{t('modbus')}</span>
                            <div className='ml-2'>
                                <span className=''>{currentModbusStatus ? t('active') :  t('notactive')}</span>
                                <LensIcon className={currentModbusStatus ? 'greenLens' : 'redLens'}/>
                            </div>
                        </div>
                        <Form
                            model='modbus'
                            onSubmit={(settings) => handleSubmit(settings)}>
                            <div className='default-row'>
                                <div className='default-field'>
                                    <Control
                                        model={".address"}
                                        component={CustomInput}
                                        label={t('modbus.address')}
                                        id={'address'} />
                                </div>
                                <div className='default-field'>
                                    <Control.select
                                        model={'.dataRate'}
                                        component={CustomSelect}
                                        label={t('dataRate')}
                                        mapProps={{
                                            options: () => dataRates.map((dr) => {
                                                return {
                                                    value: dr.value,
                                                    label: dr.value
                                                }
                                            }),
                                            id: () => 'dataRate'
                                        }}
                                        id={'dataRate'} />
                                </div>
                                <div className='default-field'>
                                    <Control.select
                                        model={'.parity'}
                                        component={CustomSelect}
                                        label={t('parity')}
                                        mapProps={{
                                            options: () => parity.map((dr) => {
                                                return {
                                                    value: dr.value,
                                                    label: dr.label
                                                }
                                            }),
                                            id: () => 'parity'
                                        }}
                                        id={'parity'} />
                                </div>
                                <div className='default-field'>
                                    <Control.select
                                        model={'.dataBits'}
                                        component={CustomSelect}
                                        label={t('dataBits')}
                                        mapProps={{
                                            options: () => dataBits.map((dr) => {
                                                return {
                                                    value: dr.value,
                                                    label: dr.value
                                                }
                                            }),
                                            id: () => 'parity'
                                        }}
                                        id={'parity'} />
                                </div>
                                <div className='default-field'>
                                    <Control.select
                                        model={'.stopBits'}
                                        component={CustomSelect}
                                        label={t('stopBits')}
                                        mapProps={{
                                            options: () => stopBits.map((dr) => {
                                                return {
                                                    value: dr.value,
                                                    label: dr.label
                                                }
                                            }),
                                            id: () => 'stopBits'
                                        }}
                                        id={'stopBits'} />
                                </div>
                            </div>
                            <div className='modal-action-row'>
                                <Button variant="outlined" disabled={dissableButtons} type='button' onClick={handleSave} color="primary" className='modal-default-button'>
                                    {t('save')}
                                </Button>
                                <Button variant="contained" disabled={dissableButtons} type='submit' color="primary" className='modal-default-button'>
                                    { !currentModbusStatus ? t('activate') : t('deactivate') }
                                </Button>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        )
    }
    return <div className='w-100 d-flex justify-content-center pt-5'>
        <Loader
            type="Puff"
            color="#555374"
            height={100}
            width={100}
            timeout={3000} //3 secs

        />
    </div>;
}
const mapStateToProps = (state: AppState) => ({
    state: state
});
export default connect(mapStateToProps)(MotbusOptionView);